import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axiosInstance.ts";
import { MobileFormEndpoints } from "@/api/mobile/form.ts";
import type { FormPage } from "@/components/features/FormBuilder/types/form.types.ts";
import { DynamicForm } from "@/components/domain/WorkOrder/Mobile/DynamicForm/DynamicForm.tsx";
import { MobileNavbarTemp } from "@/components/domain/WorkOrder/Mobile/MobileNavbar/MobileNavbar.tsx";
import { DynamicFormFooter } from "@/components/domain/WorkOrder/Mobile/DynamicForm/DynamicFormFooter/DynamicFooter.tsx";
import { authGuardWithPermissions } from "@/utils/authGuard.ts";
import type { RouterContextType } from "@/api/permissions/permissions.api.ts";

export const Route = createFileRoute("/_authenticated/mobile/work-order/jobsite-assessment/$id/")({
  component: JobsiteAssessmentDynamicFormMobile,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function JobsiteAssessmentDynamicFormMobile() {
  const formId =
    import.meta.env.VITE_JOBSITE_ASSESSMENT_FORM_ID || "019edfaa-ad99-7381-b226-5e14085f10bb";

  const { data, isLoading } = useQuery({
    queryKey: ["form", formId],
    queryFn: async () => {
      const response = await axiosInstance.get(`${MobileFormEndpoints.getById}/${formId}`);
      return response.data;
    },
  });

  const pages: FormPage[] = data?.data?.structure ?? [];

  if (isLoading) return null;

  return (
    <div>
      <MobileNavbarTemp>Jobsite Assesment</MobileNavbarTemp>

      <div style={{ padding: "16px" }}>
        <DynamicForm
          pages={pages}
          onSubmit={(formData) =>
            // TODO: Kennedy - ask team about an endpoint to submit the dynamic form(2)
            // eslint-disable-next-line no-console
            console.log(formData)
          }
        >
          <DynamicFormFooter />
        </DynamicForm>
      </div>
    </div>
  );
}
